import React from 'react';
import {
  AreaChart, Area, BarChart, Bar, LineChart, Line, ComposedChart,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Cell, ReferenceLine, ReferenceArea, Legend
} from "recharts";
import {
  RouteIcon, TrendingUp, Users, Activity, Crosshair, Sparkles,
  Trophy, ClipboardList, NotebookPen, Plus, Pencil, Trash2,
  ChevronDown, ChevronUp, Search, ArrowUpRight, ArrowDownRight,
  Download, Calendar, Clock, CheckCircle2, XCircle, AlertTriangle,
  Info, Zap, Brain, BarChart3, X, UserCheck, Building2,
  HeartHandshake, CalendarDays, CalendarCheck, Stethoscope,
  FlaskConical, Headphones, Receipt, Smartphone, Globe,
  HeartPulse, MessageSquare, ShoppingCart,
  CircleAlert, Lightbulb, TrendingDown, ScanSearch, Filter,
  Bell, Send, PanelLeftClose, PanelLeft, Archive, Link as LinkIcon, ExternalLink,
  History, Heart, MessageCircle, Share2, Upload, MapPin,
  ThumbsUp, ThumbsDown, EyeOff, Eye, Phone, Mail
} from "lucide-react";
import * as S from './_shared';
export default function TrendsView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist
  } = ctx;
  return (()=>{
        const trA = TREND_BY_AGRUP[agrupT];
        const npsTrend = trA.nps;
        const cesTrend = trA.ces;
        const csatTrend = trA.csat;
        const npsMin = Math.min(...npsTrend.map(x=>Math.min(x.n,x.s))) - 6;
        const npsMax = Math.max(...npsTrend.map(x=>Math.max(x.n,x.s))) + 8;
        const AGRUP_OPTS = [
          {k:"mes", l:"Meses",      sub:"12 meses"},
          {k:"tri", l:"Trimestres", sub:"5 trimestres"},
          {k:"sem", l:"Semestres",  sub:"5 semestres"},
          {k:"ano", l:"Anos",       sub:"4 anos"},
        ];

        // ─── REGRESSÃO LINEAR + PROJEÇÃO ────────────────────────────────────
        // Mínimos quadrados sobre os últimos N pontos da série, depois projeta
        // 6 meses e 12 meses adiante. Range é ± 1.5 × desvio padrão dos resíduos
        // (aproximação prática pra ~80% de intervalo de confiança).
        const calcTendencia = (serie, valorKey) => {
          const pontos = serie.map((p, i) => ({ x: i + 1, y: p[valorKey] }));
          const N = pontos.length;
          if (N < 3) return null;
          const xBar = pontos.reduce((s, p) => s + p.x, 0) / N;
          const yBar = pontos.reduce((s, p) => s + p.y, 0) / N;
          const num = pontos.reduce((s, p) => s + (p.x - xBar) * (p.y - yBar), 0);
          const den = pontos.reduce((s, p) => s + Math.pow(p.x - xBar, 2), 0);
          const m = den === 0 ? 0 : num / den;
          const b = yBar - m * xBar;
          // Resíduos
          const residuos = pontos.map(p => p.y - (m * p.x + b));
          const se = Math.sqrt(residuos.reduce((s, r) => s + r * r, 0) / Math.max(1, N - 2));
          // Projeções (assumindo cada ponto = 1 mês)
          const valorAtual = pontos[N - 1].y;
          const proj6 = m * (N + 6) + b;
          const proj12 = m * (N + 12) + b;
          const range = Math.max(2, Math.round(1.5 * se));
          // Classificação da tendência (slope por mês)
          const tipo = Math.abs(m) < 0.3 ? "estavel" : m > 0 ? "alta" : "baixa";
          return {
            slope: Math.round(m * 100) / 100,
            valorAtual: Math.round(valorAtual),
            proj6: { centro: Math.round(proj6), min: Math.round(proj6 - range), max: Math.round(proj6 + range) },
            proj12: { centro: Math.round(proj12), min: Math.round(proj12 - range), max: Math.round(proj12 + range) },
            tipo,
            erroPadrao: Math.round(se * 10) / 10,
          };
        };

        const tendNps  = calcTendencia(npsTrend,  "n");
        const tendCes  = calcTendencia(cesTrend,  "v");
        const tendCsat = calcTendencia(csatTrend, "v");

        const TIPO_INFO = {
          alta:    { label: "Tendência de alta",     icon: ArrowUpRight,   color: C.green },
          baixa:   { label: "Tendência de baixa",    icon: ArrowDownRight, color: C.red   },
          estavel: { label: "Tendência de estabilidade", icon: TrendingUp, color: C.orange },
        };

        return <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:C.text,letterSpacing:"-0.02em"}}>Evolução histórica</div>
            <div style={{fontSize:11,color:C.text4,marginTop:2}}>Agrupamento: <b style={{color:C.text2}}>{trA.label}</b></div>
          </div>
          {/* Seletor de granularidade */}
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <Calendar size={14} color={C.text3}/>
            <div style={{fontSize:10,color:C.text4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.06em",marginRight:2}}>Agrupar por</div>
            <div style={{display:"flex",background:C.surf3,borderRadius:11,padding:3,gap:2,border:`1px solid ${C.border}`,boxShadow:"0 1px 3px rgba(0,0,0,.04)"}}>
              {AGRUP_OPTS.map(o=>{
                const active = agrupT===o.k;
                return <button key={o.k} onClick={()=>setAgrupT(o.k)}
                  title={o.sub}
                  style={{background:active?C.g700:"transparent",color:active?"#FFFFFF":C.text2,
                    border:"none",borderRadius:8,padding:"6px 13px",fontSize:12,fontWeight:active?700:500,
                    cursor:"pointer",transition:"all .15s",
                    boxShadow:active?"0 2px 6px rgba(22,101,52,.25)":"none",fontFamily:"inherit"}}>
                  {o.l}
                </button>;
              })}
            </div>
          </div>
        </div>

        {/* === TENDÊNCIA E PROJEÇÃO — 3 cards consolidados === */}
        <Section title="Tendência atual e projeção" pad={false}
          action={<span style={{fontSize:10,color:C.text4,fontStyle:"italic"}}>Regressão linear sobre a série · ver cálculo na Metodologia</span>}>
          <div style={{padding:"4px 20px 18px"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))",gap:12}}>
              {[
                {nome:"NPS Geral",        tend:tendNps,  cor:C.g700, unidade:"pts"},
                {nome:"CES Consolidado",  tend:tendCes,  cor:C.blue, unidade:"%"},
                {nome:"CSAT Consolidado", tend:tendCsat, cor:C.g600, unidade:"%"},
              ].map(({nome, tend, cor, unidade}) => {
                if (!tend) return null;
                const info = TIPO_INFO[tend.tipo];
                const IconComp = info.icon;
                return (
                  <Card key={nome} style={{padding:"16px 18px",borderTop:`4px solid ${cor}`}}>
                    <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:10}}>
                      <div>
                        <div style={{fontSize:11,fontWeight:700,color:cor,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:2}}>{nome}</div>
                        <div style={{fontSize:24,fontWeight:700,color:C.text,letterSpacing:"-0.03em",fontFamily:F.display,lineHeight:1}}>{tend.valorAtual}{unidade}</div>
                        <div style={{fontSize:9,color:C.text4,marginTop:2}}>valor atual</div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:4,padding:"5px 10px",borderRadius:20,background:`${info.color}15`,color:info.color,fontSize:11,fontWeight:700}}>
                        <IconComp size={12}/>
                        {info.label}
                      </div>
                    </div>

                    {/* Slope explicativo */}
                    <div style={{fontSize:10,color:C.text4,marginBottom:10,paddingBottom:10,borderBottom:`1px dashed ${C.border}`}}>
                      Variação média: <b style={{color:tend.slope>0?C.green:tend.slope<0?C.red:C.text3}}>{tend.slope>0?"+":""}{tend.slope}{unidade}/período</b> · Erro padrão ±{tend.erroPadrao}{unidade}
                    </div>

                    {/* Projeção 6 meses */}
                    <div style={{marginBottom:10}}>
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:4}}>
                        <span style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:"uppercase",letterSpacing:"0.05em"}}>Projeção 6 meses</span>
                      </div>
                      <div style={{display:"flex",alignItems:"baseline",gap:6}}>
                        <span style={{fontSize:18,fontWeight:700,color:C.text,fontFamily:F.display,letterSpacing:"-0.02em"}}>{tend.proj6.min}{unidade}</span>
                        <span style={{fontSize:11,color:C.text4}}>a</span>
                        <span style={{fontSize:18,fontWeight:700,color:C.text,fontFamily:F.display,letterSpacing:"-0.02em"}}>{tend.proj6.max}{unidade}</span>
                        <span style={{marginLeft:"auto",fontSize:10,color:C.text4}}>centro {tend.proj6.centro}{unidade}</span>
                      </div>
                    </div>

                    {/* Projeção 1 ano */}
                    <div>
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:4}}>
                        <span style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:"uppercase",letterSpacing:"0.05em"}}>Projeção 12 meses</span>
                      </div>
                      <div style={{display:"flex",alignItems:"baseline",gap:6}}>
                        <span style={{fontSize:18,fontWeight:700,color:C.text,fontFamily:F.display,letterSpacing:"-0.02em"}}>{tend.proj12.min}{unidade}</span>
                        <span style={{fontSize:11,color:C.text4}}>a</span>
                        <span style={{fontSize:18,fontWeight:700,color:C.text,fontFamily:F.display,letterSpacing:"-0.02em"}}>{tend.proj12.max}{unidade}</span>
                        <span style={{marginLeft:"auto",fontSize:10,color:C.text4}}>centro {tend.proj12.centro}{unidade}</span>
                      </div>
                    </div>
                  </Card>
                );
              })}
            </div>
            <div style={{marginTop:12,padding:"10px 14px",background:C.surf3,borderRadius:8,fontSize:10,color:C.text4,lineHeight:1.6}}>
              <b style={{color:C.text3}}>Como ler:</b> projeções assumem que o ritmo de variação dos últimos meses se mantém, sem novos planos de ação ou eventos disruptivos. O range (mín–máx) reflete a incerteza estatística do modelo — quanto mais oscila a série, maior o range. <b>O cálculo completo está documentado na aba Metodologia &gt; Projeções.</b>
            </div>
          </div>
        </Section>

        <Section title={`NPS Geral — Visão ${trA.label.toLowerCase()}`} pad={false}>
          <div style={{padding:"0 20px 18px"}}>
            <ResponsiveContainer width="100%" height={260}>
              <AreaChart data={npsTrend} margin={{top:12,right:24}}>
                <defs>
                  <linearGradient id="gnps" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={C.g600} stopOpacity={.2}/><stop offset="95%" stopColor={C.g600} stopOpacity={0}/></linearGradient>
                  <linearGradient id="gsys" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor={C.g300} stopOpacity={.1}/><stop offset="95%" stopColor={C.g300} stopOpacity={0}/></linearGradient>
                </defs>
                <Zonas tipo="nps"/>
                <CartesianGrid strokeDasharray="3 3" stroke={C.border} vertical={false}/>
                <XAxis dataKey="p" tick={{fontSize:11,fill:C.text2}}/>
                <YAxis domain={[Math.max(0,npsMin),Math.min(100,npsMax)]} tick={{fontSize:10,fill:C.text4}}/>
                <Tooltip content={<TT/>}/>
                <ReferenceLine y={metas.nps} stroke={C.p500} strokeDasharray="5 3" label={{value:`Meta ${metas.nps}`,position:"right",fontSize:10,fill:C.p600}}/>
                <Legend wrapperStyle={{fontSize:12}}/>
                <Area type="monotone" dataKey="n" name="NPS Unimed" stroke={C.g600} strokeWidth={2.5} fill="url(#gnps)" dot={{fill:C.g600,r:4,strokeWidth:0}}/>
                <Area type="monotone" dataKey="s" name="Média Sist. Unimed" stroke={C.g300} strokeWidth={1.5} strokeDasharray="4 2" fill="url(#gsys)" dot={{fill:C.g300,r:3,strokeWidth:0}}/>
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </Section>

        {/* CES + CSAT consolidados */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
          <Section title="CES Consolidado — Médio das 5 etapas de esforço" pad={false}>
            <div style={{padding:"0 20px 18px"}}>
              <div style={{display:"flex",gap:16,marginBottom:8,paddingTop:4}}>
                {[["Atual",cesTrend[cesTrend.length-1].v+"%",C.blue],["Meta",cesTrend[0].meta+"%",C.p500],["Sist. Unimed",cesTrend[0].sys+"%",C.text4]].map(([l,v,c])=>(
                  <div key={l}><div style={{fontSize:9,color:C.text4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>{l}</div>
                    <div style={{fontSize:18,fontWeight:700,color:c,letterSpacing:"-0.02em"}}>{v}</div></div>
                ))}
              </div>
              <ResponsiveContainer width="100%" height={200}>
                <AreaChart data={cesTrend} margin={{top:4,right:20,bottom:0}}>
                  <defs>
                    <linearGradient id="gCesCons" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor={C.blue} stopOpacity={.2}/>
                      <stop offset="95%" stopColor={C.blue} stopOpacity={0}/>
                    </linearGradient>
                  </defs>
                  <ReferenceArea y1={0}  y2={40} fill="#99111108" strokeWidth={0}/>
                  <ReferenceArea y1={40} y2={50} fill="#dc262608" strokeWidth={0}/>
                  <ReferenceArea y1={50} y2={60} fill="#d9770608" strokeWidth={0}/>
                  <ReferenceArea y1={60} y2={70} fill="#0284c708" strokeWidth={0}/>
                  <ReferenceArea y1={70} y2={80} fill="#16a34a08" strokeWidth={0}/>
                  <ReferenceArea y1={80} y2={100} fill="#05966908" strokeWidth={0}/>
                  <CartesianGrid strokeDasharray="3 3" stroke={C.border} vertical={false}/>
                  <XAxis dataKey="p" tick={{fontSize:11,fill:C.text2}}/>
                  <YAxis domain={[Math.max(0,Math.min(...cesTrend.map(x=>x.v))-8),Math.min(100,Math.max(...cesTrend.map(x=>x.v),cesTrend[0].meta)+8)]} tick={{fontSize:10,fill:C.text4}} tickFormatter={v=>v+"%"}/>
                  <Tooltip content={<TT/>}/>
                  <ReferenceLine y={cesTrend[0].meta} stroke={C.p500} strokeDasharray="5 3" label={{value:`Meta ${cesTrend[0].meta}%`,position:"right",fontSize:9,fill:C.p600}}/>
                  <ReferenceLine y={cesTrend[0].sys}  stroke={C.g300} strokeDasharray="4 2" label={{value:`Sist. Unimed ${cesTrend[0].sys}%`, position:"right",fontSize:9,fill:C.g400}}/>
                  <Area type="monotone" dataKey="v" name="CES médio" stroke={C.blue} strokeWidth={2.5} fill="url(#gCesCons)" dot={{fill:C.blue,r:4,strokeWidth:0}}/>
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Section>

          <Section title="CSAT Consolidado — Médio das 6 etapas de satisfação" pad={false}>
            <div style={{padding:"0 20px 18px"}}>
              <div style={{display:"flex",gap:16,marginBottom:8,paddingTop:4}}>
                {[["Atual",csatTrend[csatTrend.length-1].v+"%",C.g600],["Meta",csatTrend[0].meta+"%",C.p500],["Sist. Unimed",csatTrend[0].sys+"%",C.text4]].map(([l,v,c])=>(
                  <div key={l}><div style={{fontSize:9,color:C.text4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em"}}>{l}</div>
                    <div style={{fontSize:18,fontWeight:700,color:c,letterSpacing:"-0.02em"}}>{v}</div></div>
                ))}
              </div>
              <ResponsiveContainer width="100%" height={200}>
                <AreaChart data={csatTrend} margin={{top:4,right:20,bottom:0}}>
                  <defs>
                    <linearGradient id="gCsatCons" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor={C.g600} stopOpacity={.2}/>
                      <stop offset="95%" stopColor={C.g600} stopOpacity={0}/>
                    </linearGradient>
                  </defs>
                  <ReferenceArea y1={0}  y2={40} fill="#99111108" strokeWidth={0}/>
                  <ReferenceArea y1={40} y2={50} fill="#dc262608" strokeWidth={0}/>
                  <ReferenceArea y1={50} y2={60} fill="#d9770608" strokeWidth={0}/>
                  <ReferenceArea y1={60} y2={70} fill="#0284c708" strokeWidth={0}/>
                  <ReferenceArea y1={70} y2={80} fill="#16a34a08" strokeWidth={0}/>
                  <ReferenceArea y1={80} y2={100} fill="#05966908" strokeWidth={0}/>
                  <CartesianGrid strokeDasharray="3 3" stroke={C.border} vertical={false}/>
                  <XAxis dataKey="p" tick={{fontSize:11,fill:C.text2}}/>
                  <YAxis domain={[Math.max(0,Math.min(...csatTrend.map(x=>x.v))-8),Math.min(100,Math.max(...csatTrend.map(x=>x.v),csatTrend[0].meta)+8)]} tick={{fontSize:10,fill:C.text4}} tickFormatter={v=>v+"%"}/>
                  <Tooltip content={<TT/>}/>
                  <ReferenceLine y={csatTrend[0].meta} stroke={C.p500} strokeDasharray="5 3" label={{value:`Meta ${csatTrend[0].meta}%`,position:"right",fontSize:9,fill:C.p600}}/>
                  <ReferenceLine y={csatTrend[0].sys}  stroke={C.g300} strokeDasharray="4 2" label={{value:`Sist. Unimed ${csatTrend[0].sys}%`, position:"right",fontSize:9,fill:C.g400}}/>
                  <Area type="monotone" dataKey="v" name="CSAT% médio" stroke={C.g600} strokeWidth={2.5} fill="url(#gCsatCons)" dot={{fill:C.g600,r:4,strokeWidth:0}}/>
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Section>
        </div>
        <div style={{fontSize:10,color:C.text4,fontStyle:"italic",marginTop:-4,marginBottom:-2}}>Sparklines abaixo mostram sempre a granularidade mensal por etapa, independente do agrupamento selecionado acima.</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
          {Object.entries(ETAPA_HIST).map(([nome,hist])=>{
            const cfg=JCFG[nome]; if(!cfg) return null;
            const isCes=cfg.tipo==="ces";
            const latest=(hist[hist.length-1]&&hist[hist.length-1].v);
            const first=(hist[0]&&hist[0].v);
            const st=etSt(nome,latest);
            const IcoT=JICONS[nome];
            const vals=hist.map(h=>h.v);
            const yMin=Math.max(0,Math.min(...vals,cfg.meta)-8);
            const yMax=Math.min(100,Math.max(...vals,cfg.meta)+8);
            return <Card key={nome} style={{padding:"14px 16px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:28,height:28,borderRadius:8,background:isCes?C.blueBg:C.greenBg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    {IcoT&&<IcoT size={13} color={isCes?C.blue:C.g700} strokeWidth={2}/>}
                  </div>
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:C.text,letterSpacing:"-0.01em"}}>{nome}</div>
                    <Tag label={isCes?"CES":"CSAT"} color={isCes?C.blue:C.g700}/>
                  </div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:20,fontWeight:700,color:st.color,letterSpacing:"-0.03em"}}>{latest}%</div>
                  <div style={{fontSize:10,color:(latest-first)>=0?C.green:C.red,fontWeight:600,display:"flex",alignItems:"center",gap:1,justifyContent:"flex-end"}}>
                    {(latest-first)>=0?<ArrowUpRight size={10}/>:<ArrowDownRight size={10}/>}{Math.abs(latest-first)}pp
                  </div>
                </div>
              </div>
              <ResponsiveContainer width="100%" height={72}>
                <LineChart data={hist} margin={{top:4,bottom:0,left:0,right:4}}>
                    {Z_CX.map(([y1,y2,fill],i)=><ReferenceArea key={i} y1={y1} y2={y2} fill={fill} strokeWidth={0}/>)}
                  <XAxis dataKey="p" tick={{fontSize:9,fill:C.text4}} height={14}/>
                  <YAxis domain={[yMin,yMax]} hide/>
                  <Tooltip content={({active,payload,label})=>{
                    if(!active||!(payload&&payload.length)) return null;
                    return <div style={{background:C.g900,borderRadius:7,padding:"5px 9px",fontSize:11}}>
                      <div style={{color:C.g300,marginBottom:2}}>{label}</div>
                      <div style={{color:"#fff",fontWeight:700}}>{payload[0].value}%</div>
                      <div style={{color:"rgba(255,255,255,.45)",fontSize:9}}>Meta: {cfg.meta}%</div>
                    </div>;
                  }}/>
                  <ReferenceLine y={cfg.meta} stroke={C.p500} strokeDasharray="3 2" strokeWidth={1}/>
                  <Line type="monotone" dataKey="v" stroke={st.color} strokeWidth={2} dot={{fill:st.color,r:2.5,strokeWidth:0}}/>
                </LineChart>
              </ResponsiveContainer>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:C.text4,marginTop:4}}>
                <span>Meta: {cfg.meta}%</span><span>Sist. Unimed: {cfg.sys}%</span><Tag label={st.label} color={st.color} bg={st.bg}/>
              </div>
            </Card>;
          })}
        </div>

        {/* === SÉRIE HISTÓRICA POR CIDADE === */}
        {(()=>{
          // Mock determinístico: cada cidade tem uma base + ruído por mês
          const cidadesNps = {
            "Campinas":    {base:62, ruido:[-2,-1, 0, 1, 2, 2]},
            "Sumaré":      {base:54, ruido:[ 1, 0,-1,-2,-2,-3]},
            "Hortolândia": {base:57, ruido:[ 0, 0,-1, 0,-1,-1]},
            "Paulínia":    {base:66, ruido:[-1, 0, 1, 2, 2, 3]},
            "Vinhedo":     {base:71, ruido:[-2,-1, 0, 0, 1, 1]},
            "Valinhos":    {base:68, ruido:[-3,-2, 0, 1, 3, 4]},
            "Itatiba":     {base:59, ruido:[ 0, 0, 0, 0,-1, 0]},
            "Jaguariúna":  {base:64, ruido:[-1, 0, 1, 1, 2, 2]},
          };
          const meses = ["Out","Nov","Dez","Jan","Fev","Mar"];
          const dataChart = meses.map((m,i) => {
            const row = {mes:m};
            CIDADES_COBERTURA.forEach(c => {
              const cfg = cidadesNps[c];
              if (cfg) row[c] = cfg.base + cfg.ruido[i];
            });
            return row;
          });
          // Cores por cidade — paleta consistente com o design system
          const CORES_CIDADE = [
            C.g700, C.blue, C.purple||"#7C68EE", C.orange,
            "#06b6d4", "#ec4899", "#84cc16", "#f43f5e",
          ];

          return (
            <Section title="Série histórica do NPS por cidade" pad={false}
              action={<span style={{fontSize:10,color:C.text4,fontStyle:"italic"}}>Permite identificar cidades em queda e priorizar planos de ação localizados</span>}>
              <div style={{padding:"4px 20px 18px"}}>
                <div style={{fontSize:11,color:C.text3,marginBottom:10,lineHeight:1.5}}>
                  Evolução do NPS nos últimos 6 meses por cidade da área de cobertura. Vinhedo, Valinhos e Paulínia lideram (NPS &gt; 65); Sumaré apresenta queda consistente nos últimos 3 meses.
                </div>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={dataChart} margin={{top:10,right:30,left:0,bottom:0}}>
                    <CartesianGrid strokeDasharray="3 3" stroke={C.border} vertical={false}/>
                    <XAxis dataKey="mes" tick={{fontSize:11,fill:C.text3}}/>
                    <YAxis tick={{fontSize:10,fill:C.text4}} domain={[40,80]} ticks={[40,50,60,70,80]}/>
                    <Tooltip content={<TT/>}/>
                    {CIDADES_COBERTURA.map((c,i) => (
                      <Line key={c}
                        type="monotone"
                        dataKey={c}
                        stroke={CORES_CIDADE[i % CORES_CIDADE.length]}
                        strokeWidth={2}
                        dot={{r:3, fill: CORES_CIDADE[i % CORES_CIDADE.length], strokeWidth:0}}
                        activeDot={{r:5}}
                      />
                    ))}
                    <ReferenceLine y={70} stroke={C.p500} strokeDasharray="3 2" strokeWidth={1} label={{value:"Meta 70", position:"right", fill:C.p500, fontSize:10}}/>
                  </LineChart>
                </ResponsiveContainer>
                {/* Legenda customizada */}
                <div style={{display:"flex",gap:14,flexWrap:"wrap",marginTop:12,padding:"10px 14px",background:C.surf3,borderRadius:9}}>
                  {CIDADES_COBERTURA.map((c,i) => {
                    const cor = CORES_CIDADE[i % CORES_CIDADE.length];
                    const valorAtual = dataChart[dataChart.length-1][c];
                    const valorAnt   = dataChart[0][c];
                    const delta = valorAtual - valorAnt;
                    return (
                      <div key={c} style={{display:"flex",alignItems:"center",gap:6}}>
                        <div style={{width:10,height:10,borderRadius:5,background:cor}}/>
                        <span style={{fontSize:11,color:C.text2,fontWeight:600}}>{c}</span>
                        <span style={{fontSize:11,color:C.text4}}>{valorAtual}</span>
                        {delta !== 0 && (
                          <span style={{fontSize:9,fontWeight:700,color:delta>0?C.green:C.red}}>
                            {delta>0?"↗ +":"↘ "}{delta}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Section>
          );
        })()}
      </div>;})();
}
